import { APPOINTMENT_STATUSES } from './entries';

export const DAY_HALF = {
  am: 'am',
  pm: 'pm',
};

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
export const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const MONTHS_IN_YEAR = 12;

export const DAYS_PLACEHOLDERS_FOR_CALENDAR = new Array(42).fill(1);

export const PHONE_NUMBER_MAX_LENGTH = 11;

export const HTTP_RESPONSE_STATUS_CODES = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};

export const HALF_DAY_SLOTS_VALUE = {
  '08:00': 'AM',
  '13:00': 'PM',
};

export const SAFE_URL_REGEXP = /^https:\/\//;

export const DOMAIN_TO_REPLACE = 'https://secure.business.bt.com';

export const MAP_IMAGE_PREFIX_BY_ENV_TYPE = {
  dev: '',
  test: '',
  stage: '',
  prod: '',
};

const LOG_IN = 'Log in';
const LOGIN_TO_BOOK_NEW = `${LOG_IN} to book new`;
const LOGIN_TO_CHECK_CHANGE = `${LOG_IN} to check or change`;
const LOGIN_TO_CHANGE = `${LOG_IN} to change`;
export const LOGIN_TO_CHECK = 'Log in to check';

export const LOGIN_BUTTON_TEXT = {
  [APPOINTMENT_STATUSES.CustomerMissed]: LOGIN_TO_BOOK_NEW,
  [APPOINTMENT_STATUSES.SupplierMissed]: LOGIN_TO_CHECK_CHANGE,
  [APPOINTMENT_STATUSES.Completed]: LOG_IN,
  [APPOINTMENT_STATUSES.Booked]: LOGIN_TO_CHECK_CHANGE,
  [APPOINTMENT_STATUSES.Closed]: `${LOG_IN} to change engineer visited`,
  [APPOINTMENT_STATUSES.SupplierDelayed]: LOGIN_TO_CHECK_CHANGE,
  [APPOINTMENT_STATUSES.AtRisk]: LOGIN_TO_CHANGE,
  [APPOINTMENT_STATUSES.SupplierChanged]: LOGIN_TO_CHANGE,
  [APPOINTMENT_STATUSES.Confirmed]: LOGIN_TO_CHANGE,
  [APPOINTMENT_STATUSES.ReAppointEUMissed]: 'reAppointEUMissed',
  [APPOINTMENT_STATUSES.ReAppointORMissed]: 'reAppointORMissed',
  [APPOINTMENT_STATUSES.Rejected]: LOGIN_TO_CHANGE,
};
